import React from 'react'
import { NavLink } from 'react-router-dom'
import './style.scss'

const Search = () => {
    return (
        <div className="custom-navbar">
            <div className="container">
                <div className="row">
                    <div className="col-12 text-center">
                        <NavLink
                            to="/search/"
                            className={({ isActive }) => isActive ? "btn shadow-sm isActive" : "btn shadow-sm"}
                        >basic</NavLink>
                        <NavLink
                            to="/search/advance"
                            className={({ isActive }) => isActive ? "btn shadow-sm isActive" : "btn shadow-sm"}
                        >advance</NavLink>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Search;